import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MoreHoriz } from '@material-ui/icons';
import { ConfirmationModal, CustomIconMenu } from '../../../components';
import editAccess from '../../../components/HigherOrderComponents/EditAccess';
import { AssociatedTransactionsPBA } from '../../../models';
import { TrashCanIcon } from '../../../svgs';
import { AssociatedTransactionsEventsProps } from '../PBADashboardTPDSummary.proptype';

interface AssociatedTransactionsMenuProps extends AssociatedTransactionsEventsProps {
  element: AssociatedTransactionsPBA;
  analysisType?: string;
}

export const AssociatedTransactionsMenu = ({ element, onDelete, analysisType }: AssociatedTransactionsMenuProps) => {
  const { value, transactionId } = element;
  const elementId = transactionId;
  const { t } = useTranslation();
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const items = [
    {
      text: t(`transactions:title-remove`),
      handleOnClick: () => {
        setIsConfirmationOpen(true);
      }
    }
  ]; // todo: do we wish to restrict removal of transactions from a tested party PBA?

  const handleDeletion = (confirmed: boolean) => {
    setIsConfirmationOpen(false);
    if (confirmed && elementId) {
      onDelete!(elementId);
    }
  };

  return (
    <>
      {editAccess(<CustomIconMenu Icon={MoreHoriz} menuItems={items} />)}
      {isConfirmationOpen && (
        <ConfirmationModal
          open
          title={t(`transactions:title-remove`)}
          subtitle={t('transactions:remove-transaction-subtitle', { value, analysisType })}
          text=""
          HeaderIcon={TrashCanIcon}
          handleClose={handleDeletion}
        />
      )}
    </>
  );
};
